<template>
  <div>
    <div
      id="carouselExampleIndicators"
      class="carousel slide"
      data-ride="carousel"
      v-if="slides != null"
    >
      <ol class="carousel-indicators">
        <li
          v-for="(slide, key) in slides"
          :key="key"
          data-target="#carouselExampleIndicators"
          :data-slide-to="key"
          :class="key == 0 ? 'active' : ''"
        ></li>
      </ol>
      <div class="carousel-inner">
        <div
          v-for="(slide, key) in slides"
          :key="key"
          :class="key == 0 ? 'carousel-item active' : 'carousel-item'"
        >
          <img
            class="d-block w-100"
            :src="url + '/' + slide.image"
            style="width: 1200px; height: 700;"
            alt=""
          />
        </div>
      </div>
      <a
        class="carousel-control-prev"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
    <div class="alert alert-info" v-else>
      <p class="text-center">
        Chargement en cours ...
      </p>
    </div>

    <div class="section-block">
      <div class="container">
        <div class="section-heading text-center">
          <h3 class="semi-bold">Nos récents produits</h3>
          <div class="section-heading-line line-thin dark-bg"></div>
          <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt<br>ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p> -->
        </div>
        <div class="row mt-40">
          <div
            class="col-md-4 col-sm-4 col-12"
            v-for="(product, key) in products"
            :key="key"
          >
            <div class="blog-grid">
              <img
                :src="url + '/' + product.images[0].path"
                style="width:650;heigth:500;"
                alt=""
              />
              <div class="blog-team-box">
                <h6>{{ product.service.name }}</h6>
              </div>
              <h4>
                <router-link :to="'/produit/' + product.slug">
                  {{ product.name }}
                </router-link>
              </h4>
              <p
                v-short-description="{
                  htmlText: product.description,
                  count: 150
                }"
              ></p>
              <!-- <p>
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        </p> -->
              <router-link
                :to="'/produit/' + product.slug"
                class="button-simple-primary mt-20"
              >
                Détails
                <i class="fas fa-arrow-right"></i>
              </router-link>
            </div>
          </div>
        </div>
        <div class="text-center mt-30">
          <router-link :to="'/nos-produits'" class="button-primary button-md"
            >Tous nos produits</router-link
          >
        </div>
      </div>
    </div>
    <div class="section-block grey-bg background-shape-3">
      <div class="container">
        <div class="row">
          <div class="col-md-5 col-sm-5 col-12">
            <div class="section-heading">
              <small class="uppercase">A propos de nous</small>
              <h4 class="semi-bold">IBDI, qui sommes-nous ?</h4>
            </div>
            <div class="text-content mt-15">
              <p>
                Experte en développement d'entreprise et en intermédiation, IBDI
                est une société à responsabilité limitée (SARL) qui regroupe en
                son sein des experts en Ingénierie financière, en Immobilier, en
                Accompagnement d'entreprise, en Administration et bureautique
                multi-service et en Hydraulique et Forages.
              </p>
            </div>
            <ul class="primary-list mt-20">
              <li><i class="fas fa-check-circle"></i>Professionalisme</li>
              <li><i class="fas fa-check-circle"></i>Accompagnement</li>
              <li><i class="fas fa-check-circle"></i>Satisfaction</li>
            </ul>
            <router-link
              :to="'/a-propos-de-nous'"
              class="button-md button-primary mt-30"
              >Voir plus</router-link
            >
          </div>
          <div class="col-md-6 col-sm-6 col-12 offset-md-1">
            <img
              src="/static/img/content/about/about-us-1.jpg"
              class="rounded-border shadow-primary"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="section-block">
      <div class="container">
        <div class="section-heading text-center">
          <div class="row">
            <div class="col-md-3 col-sm-6 col-12">
              <div class="countup-box">
                <h4 class="countup">150</h4>
                <h5>Clients & Partenaires</h5>
                <i class="icon-team-2"></i>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-12">
              <div class="countup-box">
                <h4 class="countup">180</h4>
                <h5>Projets terminés</h5>
                <i class="icon-box2"></i>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-12">
              <div class="countup-box">
                <h4 class="countup">60</h4>
                <h5>Appartements meublés</h5>
                <i class="icon-office-building"></i>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-12">
              <div class="countup-box">
                <h4 class="countup">370</h4>
                <h5>Réalisations & Références</h5>
                <i class="icon-diploma"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="section-block-parallax jarallax black-overlay-70"
      data-jarallax
      data-speed="0.6"
      style="background-image: url('https://ninetheme.com/themes/lumire/wp-content/uploads/2019/02/bg3-1.jpg');"
    >
      <div class="container">
        <div class="large-heading text-center">
          <small class="semi-bold white-color"
            >Nos experts sont disponibles pour méner à bien vos projets</small
          >
          <h4 class="semi-bold white-color">
            Profitez dès à présent de notre expérience et de notre
            professionnalisme.
          </h4>
          <div class="section-heading-line"></div>
        </div>
        <div class="mt-25 text-center">
          <router-link
            to="/a-propos-de-nous"
            class="button-md button-white-bordered mt-10"
            >EN SAVOIR PLUS</router-link
          >
        </div>
      </div>
    </div>
    <div class="section-block-bg">
      <div class="container">
        <div class="section-heading text-center">
          <h3 class="semi-bold">Nos services</h3>
          <div class="section-heading-line line-thin"></div>
          <!-- <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt<br>
                    ut labore et dolore magna aliqua. Ut enim ad minim veniam.
                </p> -->
        </div>
        <div class="row mt-40">
          <div
            class="col-md-4 col-sm-12 col-12"
            v-for="(service, key) in services"
            :key="key"
          >
            <div class="service-block-2">
              <img
                :src="url + '/' + service.image"
                style="width:650;heigth:500;"
                alt=""
              />
              <div class="service-block-2-content">
                <h4>
                  <router-link :to="'/service/' + service.slug">
                    {{ service.name }}
                  </router-link>
                </h4>
                <strong
                  v-short-description="{
                    htmlText: service.description,
                    count: 80
                  }"
                ></strong>
                <router-link
                  :to="'/service/' + service.slug"
                  class="service-block-2-btn"
                >
                  Détails
                  <i class="fa fa-arrow-right primary-color"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mt-30">
          <router-link :to="'/nos-services'" class="button-primary button-md"
            >Tous nos services</router-link
          >
        </div>
      </div>
    </div>
    <div
      class="section-block grey-bg jarallax"
      data-jarallax
      data-speed="0.9"
      style="background-image: url('img/content/business/bg-map.png')"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-12 col-12">
            <div class="section-heading">
              <h3 class="semi-bold">Besoin de notre expertise ?</h3>
              <!-- <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.
                        </p> -->
            </div>
            <div v-if="infos != null">
              <div class="contact-icon-box">
                <i class="icon-phone-book"></i>
                <h4>{{ infos[2].name }}</h4>
                <h5>{{ infos[2].value }}</h5>
              </div>
              <div class="contact-icon-box">
                <i class="icon-opened-email-outlined-interface-symbol"></i>
                <h4>{{ infos[0].name }}</h4>
                <h5>{{ infos[0].value }}</h5>
              </div>
              <div class="contact-icon-box">
                <i class="icon-location"></i>
                <h4>{{ infos[1].name }}</h4>
                <h5>{{ infos[1].value }}</h5>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12 col-12">
            <div class="pl-45-md">
              <div class="callback-block">
                <h4 class="bold text-center">Laissez-nous un message.</h4>
                <div class="section-heading-line line-thin"></div>
                <div class="text-content-big text-center mt-20">
                  <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore</p> -->
                </div>
                <form
                  class="primary-form mt-30"
                  @submit.prevent="submitContactForm"
                >
                  <div class="row">
                    <div class="col-md-12" v-if="formIsSubmit == true">
                      <div class="alert alert-info text-center">
                        <p>
                          Envoi du message en cours ...
                        </p>
                      </div>
                    </div>
                    <div class="col-md-12" v-if="formIsSuccess == true">
                      <div class="alert alert-success text-center">
                        <p>
                          Message envoyé avec succès !
                        </p>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <input
                        type="text"
                        name="name"
                        placeholder="Nom complet *"
                        v-model="contactForm.name"
                        required
                        :disabled="formIsSubmit == true"
                      />
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                      <the-mask
                        mask="+### ## ## ## ##"
                        type="text"
                        :masked="true"
                        placeholder="Numéro de téléphone *"
                        v-model="contactForm.phoneNumbers"
                        required
                        :disabled="formIsSubmit == true"
                      ></the-mask>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                      <input
                        type="text"
                        name="email"
                        placeholder="Adresse email"
                        v-model="contactForm.emailAddress"
                        :disabled="formIsSubmit == true"
                      />
                    </div>
                    <div class="col-md-12">
                      <input
                        type="text"
                        name="subject"
                        placeholder="Sujet *"
                        v-model="contactForm.subject"
                        required
                        :disabled="formIsSubmit == true"
                      />
                    </div>
                    <div class="col-md-12">
                      <textarea
                        name="message"
                        placeholder="Message *"
                        v-model="contactForm.content"
                        required
                        :disabled="formIsSubmit == true"
                      ></textarea>
                    </div>
                    <div class="col-md-12">
                      <vue-recaptcha
                        sitekey="6Ld-MfwUAAAAANUPUTMuKH6lv7plizKiRdqdt2Ok"
                        :loadRecaptchaScript="true"
                      >
                        <button
                          type="submit"
                          class="button-md button-primary full-width"
                          :disabled="formIsSubmit == true"
                        >
                          ENVOYER MON MESSAGE
                        </button>
                      </vue-recaptcha>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL, API_PREFIX, API_VERSION } from "../../config/urls";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "Home",
  components: { VueRecaptcha },
  data() {
    return {
      products: null,
      services: null,
      infos: null,
      slides: null,
      url: BASE_URL,
      contactForm: {
        name: null,
        phoneNumbers: null,
        emailAddress: null,
        subject: null,
        content: null
      },
      formIsSubmit: false,
      formIsSuccess: false
    };
  },
  mounted() {
    this.getProducts();
    this.getServices();
    this.getInfos();
    this.getSlides();
  },
  methods: {
    getSlides() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(BASE_URL + API_PREFIX + API_VERSION + "/slides")
          .then(response => {
            this.slides = response.data;
            resolve(this.products);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getProducts() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(BASE_URL + API_PREFIX + API_VERSION + "/products")
          .then(response => {
            this.products = response.data.slice(0, 3);
            resolve(this.products);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getServices() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(BASE_URL + API_PREFIX + API_VERSION + "/services")
          .then(response => {
            this.services = response.data.slice(0, 3);
            resolve(this.services);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getInfos() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(BASE_URL + API_PREFIX + API_VERSION + "/infos")
          .then(response => {
            this.infos = response.data;
            resolve(this.infos);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    submitContactForm() {
      this.formIsSubmit = true;
      let url = BASE_URL + API_PREFIX + API_VERSION + "/messages";
      this.$http
        .post(url, this.contactForm)
        .then(response => {
          this.formIsSubmit = false;
          this.formIsSuccess = true;
          this.contactForm = {
            name: null,
            phoneNumbers: null,
            emailAddress: null,
            subject: null,
            content: null
          };
        })
        .catch(error => {
          console.log(error.response.data);
          this.formIsSubmit = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Home.vue